/**
 * Normalizza una meta description al range consigliato per la SERP (~150-160 char).
 * Collassa gli spazi, taglia a confine di parola e aggiunge l'ellissi SOLO se ha
 * davvero troncato. Restituisce undefined per input vuoto, così i fallback a catena
 * (seo.metaDescription → excerpt → tagline) continuano a propagarsi.
 */
export const clampDescription = (s?: string | null, max = 160): string | undefined => {
  const t = (s || '').replace(/\s+/g, ' ').trim()
  if (!t) return undefined
  if (t.length <= max) return t
  const cut = t.slice(0, max - 1)
  const lastSpace = cut.lastIndexOf(' ')
  // taglia all'ultimo spazio utile; se cadrebbe troppo presto, tronca secco
  return (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).replace(/[\s,;:.–—-]+$/u, '') + '…'
}

/**
 * Risolve la <meta name="description"> scorrendo i candidati in ordine di preferenza
 * (più specifico → più generico) e restituendo il PRIMO non vuoto, già clampato.
 * Lighthouse SEO fallisce l'audit "Document does not have a meta description" se il tag
 * manca o ha content vuoto: passando un fallback sintetico garantito come ultimo candidato
 * (es. una frase che include il nome del sito) ogni pagina emette sempre una description
 * unica e descrittiva — mai vaga tipo "Home". Vedi developer.chrome.com/docs/lighthouse/seo/meta-description.
 */
export const resolveDescription = (
  ...candidates: Array<string | null | undefined>
): string | undefined => {
  for (const c of candidates) {
    const d = clampDescription(c)
    if (d) return d
  }
  return undefined
}
